import React from 'react';
import { View } from 'react-native-web';
import CustomText from './CustomText';
import { colors, spacing } from '../../utils/styling';

interface ReviewCardProps {
  photo: string;
  name: string;
  content: string;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ photo, name, content }) => {
  return (
    <View style={{
      backgroundColor: '#E5E5E5',
      borderRadius: 16,
      padding: spacing.md,
      minWidth: 220,
      maxWidth: 300,
      minHeight: 180,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: spacing.sm,
      boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    }}>
      {/* Person image, name, rating, and review */}
      <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: spacing.sm }}>
        <img
          src={photo}
          alt={name}
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            objectFit: 'cover',
            border: `2px solid ${colors.white}`,
          }}
        />
        <CustomText style={{ fontWeight: 700, fontSize: 16, color: colors.dark }}>{name}</CustomText>
        <View style={{ display: 'flex', flexDirection: 'row', marginLeft: spacing.xs }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <CustomText key={i} style={{ color: '#fec000', fontSize: 18, marginRight: 1, }}>★</CustomText>
          ))}
        </View>
      </View>
      <CustomText style={{ fontSize: 15, color: colors.dark, marginTop: spacing.xs, fontWeight: 400 }}>
        "{content}"
      </CustomText>
    </View>
  );
};

export default ReviewCard;